module.exports = __webpack_public_path__ + "img/中繼站2_數字時間.3897d0b8.png";